import React, { useEffect, useState } from 'react';
import { CloseableModal } from '../../CloseableModal';
import { ModalBody } from './ModalBody';
import { ConnectionStatus } from '../../../entities/UserIntegration';
import { SchedulingUserIntegration } from '../../../entities/SchedulingUserIntegration';
import { UserService } from '../../../services/v1/UserService';

interface PropTypes {
  isOpen: boolean;
  applicationId: number;
  interviewStageId: number;
  returnTitle?: string;
  onClose: () => void;
  atsUpdateSchedulingUserIntegrationUserInfoEnabled?: boolean;
}

function headerTitle(connectionStatus: ConnectionStatus) {
  return connectionStatus == ConnectionStatus.Disconnected ||
    connectionStatus == ConnectionStatus.Syncing
    ? 'Calendar Integration Disconnected'
    : 'Schedule Interview';
}

export function ScheduleInterviewModal(props: PropTypes) {
  const [schedulingUserIntegration, setSchedulingUserIntegration] =
    useState<SchedulingUserIntegration>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (
      props.isOpen &&
      props.atsUpdateSchedulingUserIntegrationUserInfoEnabled
    ) {
      setIsLoading(true);
      UserService.checkSchedulingUserIntegration()
        .then(setSchedulingUserIntegration)
        .finally(() => setIsLoading(false));
    }
  }, [props.isOpen]);

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.onClose()}
      isOpen={props.isOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={headerTitle(schedulingUserIntegration?.connectionStatus)}
      bodyChildren={
        <ModalBody
          isLoading={isLoading}
          connectionStatus={schedulingUserIntegration?.connectionStatus}
          {...props}
        />
      }
    />
  );
}
